/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventGroupIndex: NonNullable<unknown> }} Timeline_Track_No_Event_GroupInputs */

const en_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No event group available at index ${i?.eventGroupIndex}`)
};

const fr_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucun groupe d'evenements disponible a l'index ${i?.eventGroupIndex}`)
};

const de_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unter dem Index ${i?.eventGroupIndex} ist keine Ereignisgruppe verfügbar.`)
};

const it_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun gruppo di eventi disponibile all'indice ${i?.eventGroupIndex}`)
};

const ru_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Группа событий по индексу ${i?.eventGroupIndex} недоступна`)
};

const es_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No hay ningún grupo de eventos disponible en el índice ${i?.eventGroupIndex}`)
};

const zh_cn2_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`索引 ${i?.eventGroupIndex} 处没有可用的事件组`)
};

const ja_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`インデックス ${i?.eventGroupIndex} で利用可能なイベント グループはありません`)
};

const hi_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इंडेक्स ${i?.eventGroupIndex} पर कोई इवेंट समूह उपलब्ध नहीं है`)
};

const pt_pt2_timeline_track_no_event_group = /** @type {(inputs: Timeline_Track_No_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum grupo de eventos disponível no índice ${i?.eventGroupIndex}`)
};

/**
* | output |
* | --- |
* | "No event group available at index {eventGroupIndex}" |
*
* @param {Timeline_Track_No_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_no_event_group = /** @type {((inputs: Timeline_Track_No_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_No_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_track_no_event_group(inputs)
	if (locale === "de") return de_timeline_track_no_event_group(inputs)
	if (locale === "it") return it_timeline_track_no_event_group(inputs)
	if (locale === "ru") return ru_timeline_track_no_event_group(inputs)
	if (locale === "es") return es_timeline_track_no_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_track_no_event_group(inputs)
	if (locale === "ja") return ja_timeline_track_no_event_group(inputs)
	if (locale === "hi") return hi_timeline_track_no_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_track_no_event_group(inputs)
	return en_timeline_track_no_event_group(inputs)
});